import { render, staticRenderFns } from "./Paymentdetails.vue?vue&type=template&id=4f003e34&scoped=true"
import script from "./Paymentdetails.vue?vue&type=script&lang=js"
export * from "./Paymentdetails.vue?vue&type=script&lang=js"
import style0 from "./Paymentdetails.vue?vue&type=style&index=0&id=4f003e34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f003e34",
  null
  
)

export default component.exports